// Teacher signup intent (Sam, Oct 23 2026, TEST): someone who came in to teach
// gets teaching setup, not the Listening profile, and no birthdate/gender ask.
const KEY = 'sl_teach_intent';
export const markTeachIntent = () => {
  try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
};
export const clearTeachIntent = () => {
  try { window.localStorage.removeItem(KEY); } catch (e) {}
};
// Sam Nov 1 2026 (TEST): Teaching is locked off; a stale teach flag was turning the Listening
// profile into 'Set up teaching / Sweet Skillz' copy with a 'Save Listening Profile' button. Always listening.
export const hasTeachIntent = () => false;
const hasTeachIntentOld = () => {
  if (typeof window === 'undefined') return false;
  try {
    if (/[?&]teach=1\b/.test(window.location?.search || '')) return true;
    const at = Number(window.localStorage.getItem(KEY));
    return at > 0 && Date.now() - at < 14 * 24 * 3600 * 1000;
  } catch (e) {
    return false;
  }
};
